import moment from "moment";
import { savePayment } from "@/collections/payments";

const PAYMENT_METHOD_CASH = "cash";
const PAYMENT_METHOD_DATOFONO = "datafono";
const PAYMENT_METHOD_GOOGLE_PAY = "googlepay";
const PAYMENT_METHOD_APPLE_PAY = "applepay";
const PAYMENT_METHOD_BIZUM = "bizum";

export default {
  data() {
    return {
      paymentMethodCash: PAYMENT_METHOD_CASH,
      paymentMethodDatafono: PAYMENT_METHOD_DATOFONO,
      paymentMethodGooglePay: PAYMENT_METHOD_GOOGLE_PAY,
      paymentMethodApplePay: PAYMENT_METHOD_APPLE_PAY,
      paymentMethodBizum: PAYMENT_METHOD_BIZUM
    };
  },
  computed: {
    email() {
      return this.$store.state.customerEmail;
    },
    table() {
      return this.$store.state.tableQR;
    }
  },
  methods: {
    amountToPay(payment) {
      if (payment.payment_method === this.paymentMethodCash) {
        return parseFloat(payment.cash_payment.amount_to_pay).toFixed(2);
      }
      if (payment.payment_method === this.paymentMethodGooglePay) {
        return parseFloat(payment.google_payment.amount_to_pay).toFixed(2);
      }
      if (payment.payment_method === this.paymentMethodApplePay) {
        return parseFloat(payment.apple_payment.amount_to_pay).toFixed(2);
      }
      if (payment.payment_method === this.paymentMethodBizum) {
        return parseFloat(payment.bizum_payment.amount_to_pay).toFixed(2);
      }
      if (payment.payment_method === this.paymentMethodDatafono) {
        return parseFloat(payment.datafono_payment.amount_to_pay).toFixed(2);
      }
    },
    async initPayment({
      orders,
      paymentMethod,
      amount,
      orderAmount,
      paymentType,
      externalPaymentId
    }) {
      try {
        let _id = Date.now().toString();
        let now = moment().toDate();
        let payment = {
          tableQR: this.table,
          email: this.email,
          orders: orders,
          payment_method: paymentMethod,
          amount_paid_by_user: amount || 0,
          total_amount_order: orderAmount || 0,
          payment_type: paymentType || "product",
          isAddedToSummary: false,
          externalPaymentId: externalPaymentId || "",
          updated_on: now
        };
        // actual payment done
        await savePayment(_id, payment);
        return _id;
      } catch (error) {
        this.setlogError(
          "save_payment",
          "Obtained error message in initPayment()",
          error.stack,
          this.$options.name
        );
      }
    }
  }
};
